// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import 'rc-slider/assets/index.css'
import Slider from 'rc-slider'
import AppBar from '@material-ui/core/AppBar'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import PropStyles from 'catena/er2_styles/layer_properties'

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    )
}

type PropTypes = {
    layerProps: {
        url: string,
    },
    onChangeProps: Function,
    onClose: Function,
    pos: {
        right: number,
        top: number,
    },
    theme: PropStyles,
}

type StateTypes = {
    tabIndex: number,
}

const Handle = Slider.Handle
const handle = (props) => {
    const { dragging, ...restProps } = props
    return (
        <Handle {...restProps} />
    )
}

const styles = () => ({
    button: {
        backgroundColor: 'initial',
    },
})

class TimeseriesLayerProperties extends React.Component<PropTypes, StateTypes> {
    constructor(props) {
        super(props)
        this.state = {
            tabIndex: 0,
            ...this.props,
        }
    }

    onChangeProps = () => {
        const newlayerprops = {}
        Object.entries(this.state.layerProps).forEach((entry) => {
            const [k, v] = entry
            if (v !== this.props.layerProps[k]) {
                newlayerprops[k] = v
            }
        })
        this.props.onChangeProps(newlayerprops)
    }

    handle(sliderType, props) {
        const { value, dragging, index } = props
        if (this[sliderType]) {
            this[sliderType].textContent = value
        }
    }

    render() {
        const styles = {
            box: {
                backgroundColor: 'white',
                position: 'absolute',
                zIndex: '200',
                right: this.props.pos.right,
                top: this.props.pos.top,
                borderRadius: '5px 0px 0px 5px',
                borderLeft: '1px solid #888',
                borderTop: '1px solid #888',
                borderBottom: '1px solid #888',
            },
            slider: {
                margin: '10px 0px',
                fontWeight: 'bold',
            },
            sliderDot: {
                height: '10px',
                width: '10px',
                border: '1px',
            },
            updateButton: {
                margin: '6px',
                float: 'right',
            },
            closeButton: {
                margin: '6px',
                float: 'right',
            },
        }

        const handleChange = (event, value) => {
            this.setState({ tabIndex: value })
        }
        const changeSlider = (prop, value) => {
            this.setState({ layerProps: { ...this.state.layerProps, [prop]: value } })
        }
        const setLayersVisibility = (visibility) => {
            this.state.layerProps.layers.forEach((l) => {
                l.visible = visibility
            })
            this.setState({ layerProps: { ...this.state.layerProps } })
        }
        const toggleLayerVisibility = (layer) => {
            const layers = this.state.layerProps.layers
            const ilayer = layers.findIndex(l => l.name === layer.name)
            const ilabelLayer = layers.findIndex(l => l.name.toLowerCase().indexOf('labels') > 0 && l.name.indexOf(layer.name) === 0)
            if (ilabelLayer >= 0) {
                layers[ilabelLayer].visible = !layer.visible
            }

            const newLayer = { ...layer, visible: !layer.visible }
            this.setState({
                layerProps: {
                    ...this.state.layerProps,
                    layers: [...layers.slice(0, ilayer), newLayer, ...layers.slice(ilayer + 1)],
                },
            })
        }

        const renderLayer = layer => (
            <div key={layer.id}>
                <FormControlLabel
                    control={(
                        <Checkbox
                            checked={layer.visible}
                            onChange={() => toggleLayerVisibility(layer)}
                        />
                    )}
                    label={layer.name}
                />
            </div>
        )

        return (
            <div
                style={styles.box}
            >
                <AppBar position="static" color="secondary">
                    <Tabs value={this.state.tabIndex} onChange={handleChange}>
                        <Tab classes={{ label: this.props.theme.tabLabel }} label="General" />
                        <Tab classes={{ label: this.props.theme.tabLabel }} label="Layers" />
                    </Tabs>
                </AppBar>
                {this.state.tabIndex === 0 && (
                    <TabContainer>
                        <div style={styles.paramLabel}>
                            <span>Opacity&nbsp;</span>
                            <span>{this.state.layerProps.opacity}</span>
                            <span>&nbsp;%</span>
                        </div>
                        <Slider
                            min={0}
                            max={100}
                            style={styles.slider}
                            defaultValue={this.state.layerProps.opacity}
                            dotStyle={styles.sliderDot}
                            handle={handle}
                            onAfterChange={value => changeSlider('opacity', value)}
                        />
                    </TabContainer>
                )}

                <Button
                    classes={{
                        contained: this.props.classes.button,
                    }}
                    color="primary"
                    onClick={() => this.props.onClose()}
                    style={styles.closeButton}
                >Close
                </Button>
                <Button
                    classes={{
                        contained: this.props.classes.button,
                    }}
                    color="primary"
                    onClick={this.onChangeProps}
                    style={styles.updateButton}
                >Apply
                </Button>
            </div>
        )
    }
}

export default withStyles(styles)(TimeseriesLayerProperties)
